// extracted by mini-css-extract-plugin
export default {"actions":"actions---ONe_p","unassignAll":"unassignAll---M0S1a"};